import {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

// Configuracion de infraestructura (puertos) que el Initializer baja a las BD de
// MoneyManager y LockManager, y que esos binarios (y Theo) usan. Es una unica
// configuracion por cajero (no una lista de dispositivos).
class TabManager extends Component {
    constructor(props) {
        super(props)

        var dispositivos = props.dispositivos
        this.guardarEvent = props.event

        // Toma la config existente (primer elemento) o defaults.
        var actual = (Array.isArray(dispositivos) && dispositivos.length > 0) ? dispositivos[0] : {}

        // Campos vacios por defecto; el valor sugerido va como placeholder. Si se
        // dejan vacios, MoneyManager/LockManager mostraran error (no se hardcodea).
        // Modelos por producto. El modelo elegido se sigue guardando en el campo
        // "depositario" (lo usa el Initializer: carpeta base e imagenes de
        // CDbGraficos, y Theo / cajero como modelo de la maquina).
        this.modelosPorProducto = {
            "Depositario": ["Sinqa 10", "Sinqa 20", "Sinqa 100", "Sinqa 200", "Sinqa 500"],
            "Cajero": ["Casino NV4000", "Casino SMARTPAYOUT", "Casino CDM + BNF", "Divisas"]
        }
        this.productos = Object.keys(this.modelosPorProducto)

        var modelo = actual.depositario || ""
        this.state = {
            tipoDispositivo: props.tipoDispositivo,
            cmbProducto: actual.producto || this.productoDeModelo(modelo),
            cmbDepositario: modelo,
            txtPuertoEsp: actual.puerto_esp || ""
        }
    }

    // Configs guardadas antes de existir "producto": se deduce del modelo
    productoDeModelo = (modelo) => {
        return this.productos.find(p => this.modelosPorProducto[p].includes(modelo)) || ""
    }

    onChangeProducto = (event) => {
        var producto = event.target.value
        // Al cambiar de producto se limpia el modelo si no pertenece a la nueva lista
        var modelo = (this.modelosPorProducto[producto] || []).includes(this.state.cmbDepositario) ? this.state.cmbDepositario : ""
        this.setState({cmbProducto: producto, cmbDepositario: modelo})
    }

    onChangeDepositario = (event) => {
        this.setState({cmbDepositario: event.target.value})
    }

    onChangePuertoEsp = (event) => {
        this.setState({txtPuertoEsp: event.target.value.toString()})
    }

    // Todos los campos son OBLIGATORIOS para poder guardar. Un combo sin elegir vale
    // 0 (numero) y un texto vacio vale "" -> ambos se rechazan.
    camposValidos = () => {
        const campos = [
            this.state.cmbProducto,
            this.state.cmbDepositario,
            this.state.txtPuertoEsp
        ]
        const vacio = campos.some(v => v === undefined || v === null || v === 0 || (typeof v === 'string' && v.trim() === ""))
        if (vacio) {
            window.alert("Todos los campos son obligatorios para guardar.")
            return false
        }
        return true
    }

    btnGuardarClick = () => {
        if (!this.camposValidos()) return

        var item = {
            producto: this.state.cmbProducto,
            depositario: this.state.cmbDepositario,
            puerto_esp: this.state.txtPuertoEsp
        }

        // Config unica: se guarda como arreglo de un elemento (consistente con el
        // resto, que el Initializer lee con getJSONObject(0)).
        this.guardarEvent(this.state.tipoDispositivo, [item], () => {})
    }

    render() {
        return(
            <Box>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <Card fullWidth>
                            <CardContent>
                                <h3>Manager</h3>
                                <form>
                                    <br />
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth component="fieldset">
                                                <InputLabel id="lblProducto">Producto</InputLabel>
                                                <Select
                                                labelId="lblProducto"
                                                label="Producto"
                                                value={this.state.cmbProducto}
                                                onChange={this.onChangeProducto}>
                                                {this.productos.map(prod => (
                                                <MenuItem key={prod} value={prod}>{prod}</MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth component="fieldset" disabled={this.state.cmbProducto === ""}>
                                                <InputLabel id="lblDepositario">Modelo</InputLabel>
                                                <Select
                                                labelId="lblDepositario"
                                                label="Modelo"
                                                value={this.state.cmbDepositario}
                                                onChange={this.onChangeDepositario}>
                                                {(this.modelosPorProducto[this.state.cmbProducto] || []).map(dep => (
                                                <MenuItem key={dep} value={dep}>{dep}</MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth component="fieldset">
                                                <TextField
                                                label="Puerto Tarjeta Controladora ESP"
                                                variant="outlined"
                                                value={this.state.txtPuertoEsp}
                                                placeholder="/dev/ttyUSB0"
                                                onChange={this.onChangePuertoEsp}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                            <CardActions>
                                <Button variant="contained" onClick={this.btnGuardarClick}>Guardar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
}

export default TabManager
